module.exports = __webpack_public_path__ + "static/img/logo-grupy-call contact.1a74420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-grupy-call contact.png
// module id = 299
// module chunks = 1